// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav {
  position: fixed;
  top: 10px;
  right: 10px;
  left: 230px;
  border-radius: 5px;
  min-height: 60px;
  padding: 5px 20px;
  background-color: #fff;
  box-shadow: 0px -8px 19px 11px #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 1000;
}
.nav svg {
  color: var(--mainFont);
  margin: 0 7px;
}
.nav i {
  cursor: pointer;
}
.nav i svg {
  color: rgb(255, 173, 50) !important;
}
.nav .controls {
  display: flex;
}
.nav .bars {
  display: none;
  position: absolute;
  left: 10px;
}
.nav .bars svg {
  cursor: pointer;
}
.nav ul {
  margin: 0 10px;
  padding: 0;
  list-style-type: none;
  display: flex;
  align-items: center;
}
.nav ul li {
  position: relative;
  display: block;
}
.nav ul li svg {
  cursor: pointer;
}
.nav ul li .active-new {
  position: absolute;
  top: 2px;
  left: 18px;
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--headerFont);
}
.nav ul .bell .bellContainer,
.nav ul .cart .bellContainer {
  cursor: pointer;
}
.nav ul .bell .bellContainer span,
.nav ul .cart .bellContainer span {
  position: absolute;
  top: -5px;
  right: -3px;
  width: 18px;
  height: 18px;
  background-color: #ea5455;
  color: #fff;
  font-size: 13px;
  font-family: initial !important;
  font-weight: bold;
  border-radius: 50%;
  text-align: center;
}
.nav ul .cart span {
  background-color: #7367f0 !important;
}

.dark .nav {
  background-color: var(--darkSecondColor);
  box-shadow: 0px -8px 19px 11px #151515;
  color: var(--darkFont);
}
.dark .nav svg {
  color: var(--darkFont);
}

.rtl .nav {
  left: 10px;
  direction: rtl;
  right: 230px;
}
.rtl .nav .bars {
  right: 10px;
  left: unset;
}

@media (max-width: 1000px) {
  .nav {
    left: 10px;
    right: 10px !important;
  }
  .nav .bars {
    display: block;
  }
  .rtl .navbar {
    right: 0px;
  }
}
@media (max-width: 500px) {
  .navbar {
    padding: 0 10px;
  }
}
@media (max-width: 450px) {
  .nav {
    left: 10px;
    right: 10px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/layout/Navbar/navbar.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;AACF;AACE;EACE,sBAAA;EACA,aAAA;AACJ;AACE;EACE,eAAA;AACJ;AAAI;EACE,mCAAA;AAEN;AACE;EACE,aAAA;AACJ;AACE;EACE,aAAA;EACA,kBAAA;EACA,UAAA;AACJ;AAAI;EACE,eAAA;AAEN;AACE;EACE,cAAA;EACA,UAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;AACJ;AAAI;EACE,kBAAA;EACA,cAAA;AAEN;AADM;EACE,eAAA;AAGR;AADM;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mCAAA;AAGR;AAEM;;EACE,eAAA;AACR;AAAQ;;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EACA,+BAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAGV;AAEM;EACE,oCAAA;AAAR;;AAME;EACE,wCAAA;EACA,sCAAA;EACA,sBAAA;AAHJ;AAII;EACE,sBAAA;AAFN;;AAOE;EACE,UAAA;EACA,cAAA;EACA,YAAA;AAJJ;AAKI;EACE,WAAA;EACA,WAAA;AAHN;;AAOA;EACE;IACE,UAAA;IACA,sBAAA;EAJF;EAKE;IACE,cAAA;EAHJ;EAOE;IACE,UAAA;EALJ;AACF;AAQA;EACE;IACE,eAAA;EANF;AACF;AAQA;EACE;IACE,UAAA;IACA,sBAAA;EANF;AACF","sourcesContent":[".nav {\n  position: fixed;\n  top: 10px;\n  right: 10px;\n  left: 230px;\n  border-radius: 5px;\n  min-height: 60px;\n  padding: 5px 20px;\n  background-color: #fff;\n  box-shadow: 0px -8px 19px 11px #f0f0f0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  z-index: 1000;\n\n  svg {\n    color: var(--mainFont);\n    margin: 0 7px;\n  }\n  i {\n    cursor: pointer;\n    svg {\n      color: rgb(255, 173, 50) !important;\n    }\n  }\n  .controls {\n    display: flex;\n  }\n  .bars {\n    display: none;\n    position: absolute;\n    left: 10px;\n    svg {\n      cursor: pointer;\n    }\n  }\n  ul {\n    margin: 0 10px;\n    padding: 0;\n    list-style-type: none;\n    display: flex;\n    align-items: center;\n    li {\n      position: relative;\n      display: block;\n      svg {\n        cursor: pointer;\n      }\n      .active-new {\n        position: absolute;\n        top: 2px;\n        left: 18px;\n        display: block;\n        width: 8px;\n        height: 8px;\n        border-radius: 50%;\n        background-color: var(--headerFont);\n      }\n    }\n    .bell,\n    .cart {\n      .bellContainer {\n        cursor: pointer;\n        span {\n          position: absolute;\n          top: -5px;\n          right: -3px;\n          width: 18px;\n          height: 18px;\n          background-color: #ea5455;\n          color: #fff;\n          font-size: 13px;\n          font-family: initial !important;\n          font-weight: bold;\n          border-radius: 50%;\n          text-align: center;\n        }\n      }\n    }\n    .cart {\n      span {\n        background-color: #7367f0 !important;\n      }\n    }\n  }\n}\n.dark {\n  .nav {\n    background-color: var(--darkSecondColor);\n    box-shadow: 0px -8px 19px 11px #151515;\n    color: var(--darkFont);\n    svg {\n      color: var(--darkFont);\n    }\n  }\n}\n.rtl {\n  .nav {\n    left: 10px;\n    direction: rtl;\n    right: 230px;\n    .bars {\n      right: 10px;\n      left: unset;\n    }\n  }\n}\n@media (max-width: 1000px) {\n  .nav {\n    left: 10px;\n    right: 10px !important;\n    .bars {\n      display: block;\n    }\n  }\n  .rtl {\n    .navbar {\n      right: 0px;\n    }\n  }\n}\n@media (max-width: 500px) {\n  .navbar {\n    padding: 0 10px;\n  }\n}\n@media (max-width: 450px) {\n  .nav {\n    left: 10px;\n    right: 10px !important;\n  }\n}\n// @media(max-width:678px){\n//     .navbar{\n//         justify-content: flex-end !important;\n//         .bookmarks{\n//             display: none;\n//         }\n//     }\n// }\n// @media(max-width:400px){\n//     .navbar{\n//         .controls{\n//             flex-direction: column-reverse;\n//             align-items: center;\n//             width: 100%;\n//             padding: 10px 0;\n//         }\n//     }\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
